<section
  class="go-accordion-panel"
  [ngClass]="containerClasses"
>
  <span
    class="go-accordion-panel--selected"
    [ngStyle]="{'background': brandColor}"
  ></span>
  <header
    [attr.aria-expanded]="_expanded"
    class="go-accordion-panel__header"
    [ngClass]="headerClasses"
    (click)="toggle.emit()"
  >
    <div class="go-accordion-panel__title">
      <go-icon
        *ngIf="icon"
        [icon]="icon"
        class="go-accordion-panel__title-icon"
      ></go-icon>
      <span class="go-accordion-panel__title-text">{{ heading }}</span>
    </div>
    
    <div class="go-accordion-panel__projection">
      <ng-container *ngTemplateOutlet="headerContent"></ng-container>
    </div>

    <go-icon
      class="go-accordion-panel__control"
      icon="expand_more"
      [ngClass]="{'go-accordion-panel__control--active': _expanded}"
    ></go-icon>
  </header>

  <div [@accordionAnimation]="_expanded ? 'open' : 'close'">
    <div
      class="go-accordion-panel__content"
      [ngClass]="{
        'go-accordion-panel__content--slim': slim,
        'go-accordion-panel__content--no-padding': removeContentPadding
      }"
    >
      <ng-container *ngIf="panelContent && loaded">
        <ng-container *ngTemplateOutlet="panelContent"></ng-container>
      </ng-container>
      <ng-content *ngIf="!panelContent"></ng-content>
    </div>
  </div>
</section>
